import { TabContext, TabList, TabPanel } from "@mui/lab";
import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import NumberInput from "../../../../components/inputs/number";
import TextInput from "../../../../components/inputs/text";
import Loading from "../../../../components/loading";
import UploadPhotoV2 from "../../../../components/uploading/uploadingPhotoV2";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";
import { Box, Tab } from "@mui/material";

const FormPayment = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		//useForm
		register,
		handleSubmit,
		control,
		loading,
		//formState
		errors,
		isSubmitting,
		url_banner,
		valueTab,

		id_banner,

		handleChangeTab,
		onChangeUploadBanner,
		handleCloseModalRegister,
		handleOnSubmit,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		fetchID,

		reloadData,
		insert,
	});

	const handleOpenUpload = (e) => {
		const event = new CustomEvent("banner");
		window.dispatchEvent(event);
	};

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Aguarde buscando dados no servidor..." />
				</div>
			) : (
				<>
					<form
						className="form"
						onSubmit={handleSubmit(
							handleOnSubmit
							// handleOnError
						)}
					>
						<TabContext value={valueTab} className="">
							<Box
								sx={{
									borderBottom: 1,
									borderColor: "divider",
								}}
							>
								<TabList onChange={handleChangeTab} aria-label="lab API tabs example">
									<Tab
										label="Descrição"
										value="0"
										sx={{
											fontSize: "0.775rem",
										}}
									/>
									<Tab
										label="Imagem"
										value="1"
										sx={{
											fontSize: "0.775rem",
										}}
									/>
								</TabList>
							</Box>

							<main>
								<TabPanel value="0">
									<div className="row">
										<TextInput
											label="Descrição"
											id="descricao"
											placeholder=""
											register={register}
											errors={errors}
											autoFocus={true}
											className="col-12"
										/>
										<TextInput
											label="Slug"
											id="slug"
											placeholder=""
											register={register}
											errors={errors}
											className="col-8 col-sm-10"
										/>
										<NumberInput
											label="Ordem Visualização"
											name="ordem"
											control={control}
											errors={errors}
											className="col-4 col-sm-4 col-lg-2 truncate"
											onKeyDown={libForm.EnterTab}
											autoFocus={true}
										/>
									</div>

									<div className={`check-box col-12 col-sm-12`}>
										<div className="check-input">
											<input
												className={`${errors.ativo ? "error" : ""}`}
												id="ativo_type"
												type="checkbox"
												{...register("ativo")}
											/>
											<label htmlFor="ativo_type">
												<span className="text-sm">Ativar banner</span>
											</label>
										</div>
									</div>
								</TabPanel>
								<TabPanel value="1">
									<div className="max-w-96">
										<img src={url_banner} alt="" className="object-fill rounded-md" />
									</div>
									<button
										type="button"
										className="btn btn-sm btn-outline-primary mt-3"
										onClick={handleOpenUpload}
									>
										Selecionar Banner 1
									</button>
								</TabPanel>
							</main>
							<footer>
								<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
								<BtnSubmit isSubmitting={isSubmitting} />
							</footer>
						</TabContext>
					</form>
				</>
			)}
			<UploadPhotoV2
				onChange={onChangeUploadBanner}
				nameImg={"banner"}
				type="card"
				ident="banner"
				id={id_banner}
			/>
		</>
	);
};

export default FormPayment;
